// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2517G","footer":"styles_footer__1F_yV"};